/** 
 * @type {import("./defs").StoreProjectContract} 
 */ 
 const store = { 
 } 
 /** 
 * @returns {import("./defs").StoreProjectContract} 
 */ 
 export default function () { 
 return JSON.parse(JSON.stringify(store)); 
 }


// WEBPACK FOOTER //
// ./resources/js/storers/StoreProjectContract.js